import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { VaultProvider, useVault } from "@/context/VaultContext";
import OnboardingPage from "@/pages/OnboardingPage";
import UnlockPage from "@/pages/UnlockPage";
import ChatPage from "@/pages/ChatPage";
import PrivacyPage from "@/pages/PrivacyPage";
import DownloadPage from "@/pages/DownloadPage";
import { Loader } from "@/components/Loader";
import { ErrorBoundary } from "@/components/ErrorBoundary";

function Home() {
  const { phase, setActiveSid } = useVault();
  if (phase === "loading") return <Loader />;
  if (phase === "onboard") return <OnboardingPage />;
  if (phase === "locked") return <UnlockPage />;
  return <ErrorBoundary onRecover={() => setActiveSid(null)}><ChatPage /></ErrorBoundary>;
}

function App() {
  return (
    <VaultProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/download" element={<DownloadPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-right" />
    </VaultProvider>
  );
}

export default App;
